module.exports = __webpack_public_path__ + "static/img/wanted3.41cb214.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted3.png
// module id = vEL+
// module chunks = 1 3